import React from "react";

/**
 * Top-level safety net: any React render error inside the app will surface
 * here instead of leaving a fully blank/black page. Keeps mobile users on
 * older Safari from staring at #050505 if a third-party SDK or browser API
 * throws unexpectedly.
 */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // Surface to console so devtools / Sentry / posthog can ingest if wired.
    // eslint-disable-next-line no-console
    console.error("[Siren ErrorBoundary]", error, info?.componentStack);
  }

  handleReload = () => {
    try {
      window.location.reload();
    } catch (_) { /* noop */ }
  };

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        style={{
          minHeight: "100vh",
          background: "#050505",
          color: "#fff",
          fontFamily: "Montserrat, sans-serif",
          padding: "2.5rem 1.5rem",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <div style={{ maxWidth: 520, textAlign: "center" }}>
          <div
            style={{
              color: "#C9A227",
              fontSize: 11,
              letterSpacing: "0.3em",
              textTransform: "uppercase",
              fontWeight: 700,
              marginBottom: 18,
            }}
          >
            Signal Interrupted
          </div>
          <h1
            style={{
              fontSize: "2rem",
              fontWeight: 900,
              letterSpacing: "-0.03em",
              textTransform: "uppercase",
              lineHeight: 1.05,
              margin: "0 0 12px",
            }}
          >
            Pacific Siren is recalibrating.
          </h1>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 14, lineHeight: 1.55, margin: "0 0 24px" }}>
            Something rendered out of sequence. Reload to re-establish command.
          </p>
          <button
            type="button"
            onClick={this.handleReload}
            style={{
              background: "linear-gradient(135deg,#C5A017 0%,#C9A227 50%,#F3E5AB 100%)",
              color: "#050505",
              fontWeight: 800,
              letterSpacing: "0.2em",
              textTransform: "uppercase",
              padding: "0.85rem 1.6rem",
              border: "none",
              cursor: "pointer",
              fontSize: 12,
            }}
          >
            Reload Bridge
          </button>
        </div>
      </div>
    );
  }
}
